<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-delete-account" style="background: #fff">

    <page-title :title="'Usuwanie konta'" :back="true"></page-title>

    <template v-for="(item,index) in messages">
      <item-box-info :index="index" :item="item"></item-box-info>
    </template>

    <slide-x-left-transition :duration="400" :delay="400">
      <form-delete-account v-if="show" :disabled="disabled"></form-delete-account>
    </slide-x-left-transition>

  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import ItemBoxInfo from '@/items/ItemBoxInfo.vue';
import FormDeleteAccount from '@/forms/FormDeleteAccount.vue';
import {mapState} from "vuex";
import api from '@/services/Api';

export default {
  name: 'DeleteAccount',
  components: { PageTitle, ItemBoxInfo, FormDeleteAccount },
  computed: {
    ...mapState({
      loading: state => state.profile.loading,
      errors: state => state.profile.errors,
    })
  },
  data(){
    return {
      show: false,
      disabled: false,
      messages: null
    }
  },
  mounted(){
    this.show = true;
    // get page info
    api({url: '/users/account/delete/check', method: 'GET'}).then(resp => {
        this.messages = resp.data.data.notification.messages
        this.disabled = resp.data.data.notification.cannotBeDeleted
    })
  }
}
</script>